<template>
  <div class="add-logistics">
    <div class="form-container">
      <el-form ref="form" :rules="rules" :model="form" label-width="100px">
        <div class="flex">
          <el-form-item label="仓库：" prop="warehouseId">
            <el-select
              class="gray"
              :disabled="isUpdate"
              v-model="form.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouse"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递名称：" prop="logisticsType">
            <el-select
              :disabled="isUpdate"
              v-model="form.logisticsType"
              filterable
              class="gray"
              placeholder="请选择"
            >
              <el-option
                v-for="item in logisticsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适用范围：" v-if="1 > 2">
            <el-select
              v-model="form.customerId"
              :disabled="isUpdate"
              clearable
              filterable
              class="gray"
              placeholder="请选择"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型：" prop="expressMethod">
            <el-select
              v-model="form.expressMethod"
              :disabled="isUpdate"
              class="gray"
              placeholder="请选择"
            >
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div class="save-btn">
        <el-button
          v-show="form.expressMethod === 2"
          class="btn-blue"
          @click="saveExpressInquiry('form')"
          >保存</el-button
        >
        <el-button
          v-show="form.expressMethod !== 2"
          class="btn-blue"
          @click="openTemplateDialog"
          >模板</el-button
        >
      </div>
    </div>
    <div
      class="table-container"
      ref="table-container"
      v-show="form.expressMethod != 2"
    >
      <div
        class="list"
        v-for="(tableItem, tableIndex) in tableList"
        :key="tableIndex"
      >
        <div class="btn-container">
          <el-button @click="addNewTable" class="btn-blue" v-if="tableIndex === 0">新增表格</el-button>
          <el-button @click="delNewTable" class="btn-white" v-if="tableIndex === 0">删除表格</el-button>
          <el-button @click="openRound(tableIndex)" class="btn-white">取整规则</el-button>
        </div>
        <div class="table-img">
          <el-table :data="tableItem.tableData" style="width: 100%">
            <el-table-column label="地区">
              <template slot-scope="scope">
                <el-input
                  class="white"
                  @blur="onlyProvince(tableIndex, scope.$index, scope.row)"
                  v-model="scope.row.province"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="区间1"
              v-if="tableItem.tableTitle.length === 0"
            ></el-table-column>
            <el-table-column
              label="区间2"
              v-if="tableItem.tableTitle.length === 0"
            ></el-table-column>
            <el-table-column
              v-for="(title, index) in tableItem.tableTitle"
              :key="index"
              :label="
                index + 1 === tableItem.tableTitle.length
                  ? title.value + unit
                  : title.value + unit
              "
            >
              <el-table-column v-if="!title.fixedPrice" :label="`首重（元/${unit}）`">
                <template slot-scope="scope">
                  <el-input
                    class="white"
                    v-model="scope.row[title.value].firstWeight"
                    @input="
                      inputPriceLimit(
                        scope.row,
                        title.value,
                        'firstWeight',
                        scope.row[title.value].firstWeight
                      )
                    "
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column v-if="!title.fixedPrice" :label="`续重（元/${unit}）`">
                <template slot-scope="scope">
                  <el-input
                    class="white"
                    v-model="scope.row[title.value].overPrice"
                    @input="
                      inputPriceLimit(
                        scope.row,
                        title.value,
                        'overPrice',
                        scope.row[title.value].overPrice
                      )
                    "
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                v-if="title.fixedPrice"
                :label="`首重（元/${unit}）`"
              >
                <template slot-scope="scope">
                  <el-input
                    class="white"
                    v-model="scope.row[title.value]"
                    @input="
                      inputPriceLimit(
                        scope.row,
                        title.value,
                        'fixedPrice',
                        scope.row[title.value]
                      )
                    "
                  ></el-input>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                <el-button
                  class="btn-text"
                  type="text"
                  @click="openTableTitleDialog(tableIndex)"
                  >编辑</el-button
                >
              </template>
              <template slot-scope="scope">
                <el-button
                  class="btn-text"
                  type="text"
                  @click="removeTableList(tableIndex, scope.$index)"
                  >删除</el-button
                >
                <el-button
                  v-if="scope.$index === tableItem.tableData.length - 1"
                  class="btn-text"
                  type="text"
                  @click="addTableList(tableIndex)"
                  >添加</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="option">
          <el-button class="btn-blue" @click="saveTableItem('form', tableIndex)"
            >保存</el-button
          >
          <el-button
            class="btn-blue"
            v-if="tableItem.tableData.length === 0"
            @click="addTableList(tableIndex)"
            >添加</el-button
          >
        </div>
      </div>
    </div>
    <!-- 表头编辑 -->
    <el-dialog
      title="编辑"
      top="15vh"
      :visible.sync="tableTitleDialog"
      width="720px"
    >
      <div class="border"></div>
      <ul class="list">
        <li
          class="item"
          v-for="(value, index) in tableList[tableTitleIndex].intervalList"
          :key="index"
        >
          <span>首重区间{{ index + 1 }}：</span>
          <p class="interval">
            <el-input class="white" v-model="value.start" disabled></el-input>
            <span class="blank">---</span>
            <el-input
              class="white"
              @blur="blurTableTitle(tableTitleIndex, index, value.end)"
              v-model="value.end"
              :disabled="
                index === tableList[tableTitleIndex].intervalList.length - 1
                  ? true
                  : false
              "
            ></el-input>
            <span class="first-weight">首重：</span>
            <el-input class="white first-weight-val" v-model="value.firstWeightVal" placeholder="输入值≤左区间" :disabled='index === 0'></el-input>
            <el-checkbox class="fixedPrice" v-model="value.fixedPrice"
              >固定价</el-checkbox
            >
            <el-button
              type="text"
              class="btn-text"
              v-show="index !== 0?
                index === tableList[tableTitleIndex].intervalList.length - 2
                :false
              "
              @click="deleteInterval(tableTitleIndex, index)"
              >删除</el-button
            >
          </p>
        </li>
      </ul>
      <p class="add-interval">
        <el-button
          class="btn-text"
          type="text"
          @click="addInterval(tableTitleIndex)"
          >+添加区间</el-button
        >
      </p>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="selectTableTitle(tableTitleIndex)"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 取整规则编辑 -->
    <el-dialog
      title="取整规则"
      top="15vh"
      :visible.sync="roundDialog"
      width="600px"
    >
      <div class="border"></div>
      <ul class="list">
        <li
          class="item"
          v-for="(value, index) in tableList[tableTitleIndex].roundTableList"
          :key="index"
        >
          <span>区间{{ index + 1 }}：</span>
          <div class="interval">
            <el-input class="white" v-model="value.start" disabled></el-input>
            <span class="blank">---</span>
            <el-input
              class="white"
              v-model="value.end"
              @blur="blurRoundTableTitle(index, value.end)"
              :disabled="
                index === tableList[tableTitleIndex].roundTableList.length - 1
                  ? (value.end >= 9999.9?true:false)
                  : false
              "
              @input="inputRoundEnd(index, value.end)"
            ></el-input>
            <div class="throw-rule">
              <span>取整规则：</span>
              <div class="input-container">
                <el-select class="gray w100" v-model="value.roundType">
                  <el-option
                    v-for="item in roundList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <el-button
              type="text"
              class="btn-text"
              v-show="index !== 0?
                index === tableList[tableTitleIndex].roundTableList.length - 1
                : false
              "
              @click="deleteRoundInterval(index)"
              >删除</el-button
            >
          </div>
        </li>
      </ul>
      <p class="add-interval">
        <el-button
          class="btn-text"
          type="text"
          @click="addRoundInterval"
          >+添加区间</el-button
        >
      </p>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeRoundDialog">取消</el-button>
        <el-button class="btn-blue" @click="selectRoundTableTitle"
          >确定</el-button
        >
      </div>
    </el-dialog>
    
    <!-- 模板 -->
    <el-dialog title="模板" top="35vh" :visible.sync="addLogisticsRuleDialog" width="420px">
      <div class="border"></div>
      <el-form
        ref="logisticsForm"
        :rules="logisticsFormRules"
        :model="logisticsForm"
        label-width="80px"
      >
        <el-form-item label="仓库：" prop="warehouseId">
          <el-select
            class="gray"
            v-model="logisticsForm.warehouseId"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouse"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递名称：" prop="logisticsType">
          <el-select
            v-model="logisticsForm.logisticsType"
            class="gray"
            placeholder="请选择"
          >
            <el-option
              v-for="item in logisticsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeAddLogisticsRuleDialog">取消</el-button>
        <el-button class="btn-blue" @click="selectTemplate('logisticsForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Logistics from "models/logistics";
import ExpressInquiry from "models/express-inquiry";
import Expenses from "models/expenses";
const expenses = new Expenses();
const logistics = new Logistics();
const expressInquiry = new ExpressInquiry();
export default {
  data() {
    return {
      isUpdate: false,
      form: {
        warehouseId: "",
        logisticsType: "",
        customerId: "",
        expressMethod: 1,
      },
      rules: {
        warehouseId: {
          required: true,
          message: "请选择仓库",
          trigger: "change",
        },
        logisticsType: {
          required: true,
          message: "请选择快递",
          trigger: "change",
        },
        expressMethod: {
          required: true,
          message: "请选择类型",
          trigger: "change",
        },
      },
      warehouse: [],
      logisticsList: [],
      customerList: [],
      expressList: [
        {
          id: 1,
          name: "计重",
        },
        {
          id: 2,
          name: "现场定价",
        },
        {
          id: 3,
          name: "计体积",
        },
      ],
      //规则
      tableTitleDialog: false,
      isEdit: false,
      tableTitleIndex: 0,
      tableList: [
        {
          tableTitle: [],
          tableData: [], //表格数据
          intervalList: [
            {
              start: 0,
              end: "",
              firstWeightVal: 0,
              fixedPrice: false,
            },
            {
              start: "",
              end: 9999.9,
              firstWeightVal: 1
            },
          ],
          // 取整规则列表
          roundTableList: [
            {
              start: 0,
              end: "9999.9",
              roundType: '',
            },
          ],
          roundTypeList: [],      // 提交的取整规则区间数据
        },
      ],
      roundList: [],
      roundDialog: false,
      unit: 'kg',
      addLogisticsRuleDialog: false,
      logisticsForm: {
        warehouseId: "",
        logisticsType: "",
      },
      logisticsFormRules: {
        warehouseId: {
          required: true,
          message: "请选择仓库",
          trigger: "change",
        },
        logisticsType: {
          required: true,
          message: "请选择快递",
          trigger: "change",
        },
      },
    };
  },
  created() {
    this.form.expressMethod = this.$route.query.expressMethod
      ? Number(this.$route.query.expressMethod)
      : "";
    this.unit = this.form.expressMethod == 3 ? 'm³' : 'kg'
    this.getLogisticsList();
    this.getWarehouse();
    this.getCustomerList();
    this.initGetRoundList()
    this.isUpdate = this.$route.query.isUpdate == 1 ? true : false;
  },
  mounted() {
    if (this.$route.query.isUpdate == 1) {
      let warehouseId = Number(this.$route.query.warehouseId);
      let expressType = Number(this.$route.query.expressType);
      this.expressDetail(warehouseId, expressType);
    }
  },
  methods: {
    /* 限制小数点后两位 */
    inputPriceLimit(row, index, type, val) {
      if (val == '.') {
        val = ''
      }
      let numLimit = val.toString().match(/^\d*(\.?\d{0,3})/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^\d*(\.?\d{0,3})/g)[0]
        : "";
      if (type === 'firstWeight') {
        row[index].firstWeight = numLimit
      } else if (type === 'overPrice') {
        row[index].overPrice = numLimit
      } else {
        row[index] = numLimit
      }
    },
    /* 获取取整规则 */
    initGetRoundList() {
      logistics.getRoundList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.code;
            obj.name = value.name;
            arr.push(obj);
          });
          this.roundList = arr
          this.tableList[0].roundTableList[0].roundType = this.roundList[0].id
        }
      })
    },
    //新增表格
    addNewTable() {
      let obj = {
        tableTitle: [],
        tableData: [], //表格数据
        intervalList: [
          {
            start: 0,
            end: "",
            fixedPrice: false,
            firstWeightVal: 0,
          },
          {
            start: "",
            end: 9999.9,
            firstWeightVal: 1
          },
        ],
        // 取整规则列表
        roundTableList: [
          {
            start: 0,
            end: "9999.9",
            roundType: this.roundList[0].id,
          },
        ],
        roundTypeList: [],      // 提交的取整规则区间数据
      };
      this.tableList.push(obj);
      setTimeout(() => {
        let h = this.$refs["table-container"].clientHeight + 140;
        document
          .getElementById("pageContent")
          .scroll({ top: h, left: 0, behavior: "smooth" });
      }, 100);
    },
    //删除表格
    delNewTable() {
      if (this.tableList.length !== 1) {
        if (this.isUpdate) {
          let data = {};
          data.customerId = Number(this.$route.query.customerId);
          data.expressType = Number(this.$route.query.expressType);
          data.warehouseId = Number(this.$route.query.warehouseId);
          data.sort = this.tableList.length;
          expenses.postDelet(data).then((res) => {
            if (res.success) {
              console.log("删除成功");
            } else {
              console.log("删除失败");
            }
          });
        }
        if (this.isEdit) {
          this.tableTitleIndex = this.tableTitleIndex - 1
        }
        this.tableList.splice(this.tableList.length - 1, 1);
      }
    },
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
          if (this.$route.query.warehouseId) {
            this.form.warehouseId = Number(this.$route.query.warehouseId);
          }
        }
      });
    },
    //获取快递类型
    getLogisticsList() {
      logistics.getExpressData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.logisticsList = arr;
          if (this.$route.query.warehouseId) {
            this.form.logisticsType = Number(this.$route.query.expressType);
          }
        }
      });
    },
    //获取客户列表
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
          if (
            this.$route.query.customerId &&
            this.$route.query.customerId != 0
          ) {
            this.form.customerId = Number(this.$route.query.customerId);
          } else {
            this.form.customerId = "";
          }
        }
      });
    },
    initTableList() {
      this.tableList = [
        {
          tableTitle: [],
          tableData: [], //表格数据
          intervalList: [
            {
              start: 0,
              end: "",
              firstWeightVal: 0,
              fixedPrice: false,
            },
            {
              start: "",
              end: 9999.9,
              firstWeightVal: 1
            },
          ],
          // 取整规则列表
          roundTableList: [
            {
              start: 0,
              end: "9999.9",
              roundType: '',
            },
          ],
          roundTypeList: [],      // 提交的取整规则区间数据
        },
      ]
    },
    //获取详情
    expressDetail(warehouseId, expressType) {
      let expressMethod = Number(this.$route.query.expressMethod);
      expressInquiry
        .getExpressDetail(warehouseId, expressType, expressMethod)
        .then(async (res) => {
          if (res.success) {
            await this.initTableList()
            let tableList = [];
            this.form.expressMethod = res.result.expressMethod;
            res.result.ruleList.map((tableListItem) => {
              let tableObj = {};
              let tableTitle = [];
              let tableData = [];
              let intervalList = [];
              let roundTableList = [];
              let roundTypeList = [];
              let overPrice = "";
              tableListItem.section.map((value) => {
                let obj = {};
                let obj2 = {};
                obj.value = value.begin + "-" + value.end;
                obj.firstWeightVal = value.unitWeight;
                obj2.start = value.begin;
                obj2.end = value.end;
                tableTitle.push(obj);
                intervalList.push(obj2);
              });
              tableListItem.rules.map((value) => {
                let obj = {};
                obj.province = value.province;
                value.ruleDetail.map(v => {
                  if (v.over === 0) {
                    obj[v.begin + "-" + v.end] = v.price;
                  } else {
                    obj[v.begin + "-" + v.end] = {}
                    obj[v.begin + "-" + v.end].overPrice = v.over;
                    obj[v.begin + "-" + v.end].firstWeight = v.price;
                  }
                  tableTitle.map(val => {
                    let str = v.begin + "-" + v.end
                    if (val.value === str) {
                      if (v.over === 0) {
                        val.fixedPrice = true
                      } else {
                        val.fixedPrice = false
                      }
                    }
                  })
                  intervalList.map(val => {
                    if (val.start === v.begin&&val.end === v.end) {
                      val.firstWeightVal = v.unitWeight;
                      if (v.over === 0) {
                        val.fixedPrice = true
                      } else {
                        val.fixedPrice = false
                      }
                    }
                  })
                  // obj[v.begin + "-" + v.end] = v.price;
                  // if (value.ruleDetail.length - 1 === i) {
                  //   obj.overPrice = v.over;
                  //   overPrice = v.over;
                  // }
                });
                tableData.push(obj);
              });
              if (tableListItem.roundTypeList.length === 0 || tableListItem.roundTypeList === null) {
                let roundArr = [
                  {
                    start: 0,
                    end: "9999.9",
                    roundType: this.roundList[0].id,
                  },
                ]
                roundTableList = roundArr
                roundTypeList = [
                  {
                    begin: 0,
                    end: "9999.9",
                    roundType: this.roundList[0].id,
                  },
                ]

              } else {
                tableListItem.roundTypeList.map(i => {
                  let obj = {}
                  let obj2 = {}
                  obj.start = i.begin
                  obj.end = i.end
                  obj.roundType = i.roundType
                  obj2.begin = i.begin
                  obj2.end = i.end
                  obj2.roundType = i.roundType
                  roundTableList.push(obj)
                  roundTypeList.push(obj2)
                })
              }
              tableObj = {
                tableTitle,
                tableData,
                intervalList,
                overPrice,
                roundTableList,
                roundTypeList
              };
              tableList.push(tableObj);
            })
            if (tableList.length > 0) {
              this.tableList = tableList;
            }
          } else {
            this.$message.error(res.message);
          }
        });
    },
    //现场定价
    saveExpressInquiry(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {};
          data.customerId =
            this.form.customerId === "" ? 0 : this.form.customerId;
          data.expressType = this.form.logisticsType;
          data.expressMethod = this.form.expressMethod;
          data.warehouseId = this.form.warehouseId;
          expressInquiry.postExpressAddRule(data).then((res) => {
            if (res.success) {
              this.$message.success("添加成功");
              this.$router.push("/base-info/carrier/express/express-inquiry");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    openTableTitleDialog(tableTitleIndex) {
      this.tableTitleDialog = true;
      this.isEdit = true
      this.tableTitleIndex = tableTitleIndex;
    },
    closeDialog() {
      this.tableTitleDialog = false;
    },
    removeTableList(tableIndex, index) {
      this.tableList[tableIndex].tableData.splice(index, 1);
    },
    addTableList(tableIndex) {
      if (this.tableList[tableIndex].tableTitle.length === 0) {
        this.$message.error("请添加区间");
      } else {
        let obj = {};
        obj.province = "";
        this.tableList[tableIndex].tableTitle.map((value) => {
          if (value.fixedPrice) {
            obj[value.value] = "";
          } else {
            obj[value.value] = {};
            obj[value.value].firstWeight = "";
            obj[value.value].overPrice = "";
          }
        });
        this.tableList[tableIndex].tableData.push(obj);
      }
    },
    saveTableItem(formName, tableIndex) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.tableList[tableIndex].tableData.length > 0) {
            let data = {};
            let arr = [];
            let stop = false;
            let num = 0;
            this.tableList[tableIndex].tableData.map((value) => {
              num = 0;
              Object.keys(value).forEach((key) => {
                this.tableList[tableIndex].tableTitle.map((v, i) => {
                  if (v.value === key) {
                    num = num + 1;
                    let obj = {};
                    obj.province = value.province;
                    obj.unitWeight = v.firstWeightVal
                    obj.begin = Number(key.split("-")[0]);
                    obj.end = Number(key.split("-")[1]);
                    if (v.fixedPrice) {
                      obj.price = Number(value[key]);
                      obj.over = 0;
                      obj.fixedPrice = 1;
                    } else {
                      obj.price = Number(value[key].firstWeight);
                      obj.over = Number(value[key].overPrice);
                      obj.fixedPrice = 0;
                    }
                    if (value.province === "" || value[key] === "") {
                      stop = true;
                    }
                    arr.push(obj);
                  }
                });
              });
            });
            let isOver = false
            arr.map(i => {
              if ((i.over === 0||i.over === '')&&i.fixedPrice === 0) {
                isOver = true
              }
            })
            if (isOver) {
              this.$message.error("续重不能为空和0");
              return false;
            }
            if (num !== this.tableList[tableIndex].tableTitle.length) {
              this.$message.error("地区或区域价格不能为空");
              return false;
            }
            if (!stop) {
              if (this.tableList[tableIndex].roundTypeList.length === 0) {
                let arr = []
                this.tableList[tableIndex].roundTableList.map(i => {
                  let obj = {}
                  obj.begin = i.start
                  obj.end = i.end
                  obj.roundType = i.roundType
                  arr.push(obj)
                })
                data.roundTypeList = arr;
              } else {
                data.roundTypeList = this.tableList[tableIndex].roundTypeList;
              }
              data.customerId =
                this.form.customerId === "" ? 0 : this.form.customerId;
              data.expressType = this.form.logisticsType;
              data.expressMethod = this.form.expressMethod;
              data.warehouseId = this.form.warehouseId;
              data.list = arr;
              data.sort = tableIndex + 1;
              expressInquiry.postExpressAddRule(data).then((res) => {
                if (res.success) {
                  this.$message.success("添加成功");
                  // this.$router.push("/base-info/carrier/express/express-inquiry");
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              this.$message.error("地区或区域价格不能为空");
            }
          } else {
            this.$message.error("请添加规则");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //唯一区域
    onlyProvince(tableIndex, ind, row) {
      let province = row.province;
      if (province !== "") {
        this.tableList.map((value, index) => {
          value.tableData.map((v, i) => {
            if (index !== tableIndex || i !== ind) {
              if (v.province === province) {
                this.$message.error("区域重复");
                row.province = "";
              }
            }
          });
        });
      }
    },
    blurTableTitle(tableTitleIndex, index, value) {
      if (!Number.isNaN(Number(value)) && Number(value) > 0) {
        this.tableList[tableTitleIndex].intervalList[index + 1].start = value;
        if (this.tableList[tableTitleIndex].intervalList[index].start < 1) {
          this.tableList[tableTitleIndex].intervalList[index].fixedPrice = true;
        }
      } else {
        this.tableList[tableTitleIndex].intervalList[index].end = "";
        this.tableList[tableTitleIndex].intervalList[index + 1].start = "";
      }
    },
    //删除区间
    deleteInterval(tableTitleIndex, index) {
      this.tableList[tableTitleIndex].intervalList.splice(index, 1);
      let length = this.tableList[tableTitleIndex].intervalList.length - 2;
      let lengthFirst = this.tableList[tableTitleIndex].intervalList.length - 1;
      this.tableList[tableTitleIndex].intervalList[lengthFirst].start = this.tableList[tableTitleIndex].intervalList[length].end
    },
    //新增区间
    addInterval(tableTitleIndex) {
      let length = this.tableList[tableTitleIndex].intervalList.length - 2;
      let lengthFirst = this.tableList[tableTitleIndex].intervalList.length - 1;
      let endVal = this.tableList[tableTitleIndex].intervalList[lengthFirst].end
      let index
      let obj
      if (endVal != 9999.9) {
        obj = {
          start: this.tableList[tableTitleIndex].intervalList[lengthFirst].end,
          end: "9999.9",
          firstWeightVal: 1,
          fixedPrice: false,
        };
        index = this.tableList[tableTitleIndex].intervalList.length;
      } else {
        obj = {
          start: this.tableList[tableTitleIndex].intervalList[length].end,
          end: "",
          firstWeightVal: 1,
          fixedPrice: false,
        };
        index = this.tableList[tableTitleIndex].intervalList.length - 1;
        this.tableList[tableTitleIndex].intervalList[lengthFirst].start = ''
      }
      this.tableList[tableTitleIndex].intervalList.splice(index, 0, obj);
    },
    //表头编辑确定
    selectTableTitle(tableTitleIndex) {
      setTimeout(() => {
        let tableTitle = [];
        let isStop = false;
        let isFlag = false;
        let isFirstWeightVal = false;
        let isFirstWeight = false;
        this.tableList[tableTitleIndex].intervalList.map((value) => {
          let obj = {};
          obj.value = value.start + "-" + value.end;
          obj.fixedPrice = value.fixedPrice;
          obj.firstWeightVal = value.firstWeightVal;
          obj.firstWeight = "";
          obj.overPrice = "";
          tableTitle.push(obj);
          if (value.start === "" || value.end === "") {
            isStop = true;
            return false;
          }
          if (Number(value.start) >= Number(value.end)) {
            isFlag = true;
            return;
          }
          if (value.firstWeightVal === '') {
            isFirstWeightVal = true;
            return;
          }
          if (Number(value.firstWeightVal) > Number(value.start)) {
            isFirstWeight = true;
            return;
          }
        });
        if (isStop) {
          this.$message.error("区间价不能为空");
          return false;
        }
        if (isFlag) {
          this.$message.error("左区间必须小于右区间");
          return false;
        }
        if (isFirstWeightVal) {
          this.$message.error("首重不能为空");
          return false;
        }
        if (isFirstWeight) {
          this.$message.error("首重要小于等于左区间");
          return false;
        }
        let tableData = [];
        this.tableList[tableTitleIndex].tableData.map((i) => {
          let obj = {};
          obj.province = i.province;
          tableTitle.map((val) => {
            if (val.fixedPrice) {
              obj[val.value] = "";
            } else {
              obj[val.value] = {};
              obj[val.value].firstWeight = "";
              obj[val.value].overPrice = "";
            }
            Object.keys(i).forEach((key) => {
              if (key === val.value) {
                if (val.fixedPrice) {
                  if (typeof i[key] === "object") {
                    obj[val.value] = Number(i[key].firstWeight);
                  } else {
                    obj[val.value] = Number(i[key]);
                  }
                } else {
                  if (typeof i[key] === "object") {
                    if (i[key].firstWeight) {
                      obj[val.value].firstWeight = Number(i[key].firstWeight);
                    } else {
                      obj[val.value].firstWeight = '';
                    }
                  } else {
                    obj[val.value].firstWeight = Number(i[key]);
                  }
                  if (i[key].overPrice) {
                    obj[val.value].overPrice = Number(i[key].overPrice);
                  } else {
                    obj[val.value].overPrice = '';
                  }
                }
              }
            });
          });
          tableData.push(obj);
        });
        this.tableList[tableTitleIndex].tableData = [];
        this.$nextTick(() => {
          this.tableList[tableTitleIndex].tableData = tableData;
        })
        this.tableList[tableTitleIndex].tableTitle = tableTitle;
        this.closeDialog();
      },200)
    },
    // 打开取整规则
    openRound(tableTitleIndex) {
      this.tableTitleIndex = tableTitleIndex
      this.roundDialog = true
    },
    // 关闭取整规则
    closeRoundDialog() {
      this.roundDialog = false
    },
    // 添加取整规则区间
    addRoundInterval() {
      let lengthFirst = this.tableList[this.tableTitleIndex].roundTableList.length - 1;
      let endVal = this.tableList[this.tableTitleIndex].roundTableList[lengthFirst].end
      let index
      let obj
      if (endVal != 9999.9) {
        obj = {
          start: this.tableList[this.tableTitleIndex].roundTableList[lengthFirst].end,
          end: "9999.9",
          roundType: this.roundList[0].id
        };
        index = this.tableList[this.tableTitleIndex].roundTableList.length;
      } else {
        obj = {
          start: this.tableList[this.tableTitleIndex].roundTableList[lengthFirst].start,
          end: "",
          roundType: this.roundList[0].id
        };
        index = this.tableList[this.tableTitleIndex].roundTableList.length - 1;
        this.tableList[this.tableTitleIndex].roundTableList[lengthFirst].start = ''
      }
      this.tableList[this.tableTitleIndex].roundTableList.splice(index, 0, obj);
    },
    // 删除取整规则区间
    deleteRoundInterval(index) {
      this.tableList[this.tableTitleIndex].roundTableList.splice(index, 1);
      let lengthFirst = this.tableList[this.tableTitleIndex].roundTableList.length - 1;
      this.tableList[this.tableTitleIndex].roundTableList[lengthFirst].end = 9999.9
    },
    // 上一个区间的右区间的值带入下一个区间的左区间的值
    blurRoundTableTitle(index, value) {
      if (!Number.isNaN(Number(value)) && Number(value) > 0) {
        this.tableList[this.tableTitleIndex].roundTableList[index + 1].start = value;
      } else {
        this.tableList[this.tableTitleIndex].roundTableList[index].end = "";
        this.tableList[this.tableTitleIndex].roundTableList[index + 1].start = "";
      }
    },
    // 取整规则区间确认提交
    selectRoundTableTitle() {
      let arr = [];
      let isStop = false;
      let isFlag = false;
      this.tableList[this.tableTitleIndex].roundTableList.map((value) => {
        let obj = {};
        obj.begin = Number(value.start)
        obj.end = Number(value.end)
        obj.roundType = value.roundType;
        arr.push(obj);
        if (value.start === "" || value.end === "") {
          isStop = true;
          return false;
        }
        if (Number(value.start) >= Number(value.end)) {
          isFlag = true;
          return;
        }
      });
      if (isStop) {
        this.$message.error("区间价不能为空");
        return false;
      }
      if (isFlag) {
        this.$message.error("左区间必须小于右区间");
        return false;
      }
      this.tableList[this.tableTitleIndex].roundTypeList = arr
      this.closeRoundDialog();
    },
    /* 限制区间大于9999.9 */
    inputRoundEnd(index, val) {
      if (Number(val) >= 9999.9) {
        this.tableList[this.tableTitleIndex].roundTableList[index].end = 9999.9
      }
    },

    openTemplateDialog() {
      this.addLogisticsRuleDialog = true
    },

    closeAddLogisticsRuleDialog() {
      this.$refs["logisticsForm"].resetFields();
      this.tableTitleDialog = false;
      this.addLogisticsRuleDialog = false
    },
    
    //模板选择
    selectTemplate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.logisticsForm.warehouseId
          let expressType = this.logisticsForm.logisticsType
          this.expressDetail(warehouseId, expressType);
          this.closeAddLogisticsRuleDialog()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.add-logistics {
  flex: 1;
  display: flex;
  flex-direction: column;
  .form-container {
    padding: 16px;
    padding-bottom: 0;
    background: #fff;
    margin-bottom: 16px;
    border-radius: 4px;
    .el-form {
      .flex {
        display: flex;
      }
    }
    .save-btn {
      margin-left: 100px;
      margin-bottom: 16px;
    }
  }
  .btn-container {
    margin-bottom: 16px;
    justify-content: space-between;
  }
  .list {
    margin-bottom: 16px;
  }
  .table-container {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .table {
      display: flex;
    }
    .option {
      padding-top: 16px;
      display: flex;
      justify-content: space-between;
    }
  }
  .el-dialog {
    .el-form {
      padding: 0 30px 0 10px;
      .el-select {
        width: 100%;
      }
    }
    .list {
      padding: 0 18px;
      max-height: 235px;
      overflow: auto;
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .interval {
          align-items: center;
          display: flex;
          .blank {
            padding: 0 10px;
          }
          .el-input {
            width: 100px;
          }
          .btn-text {
            font-size: 12px;
            margin-left: 16px;
          }
          .fixedPrice {
            margin-left: 10px;
          }
        }
      }
      .item:last-child {
        margin-bottom: 0;
      }
    }
    .add-interval {
      padding-left: 30px;
      .btn-text {
        font-size: 12px;
      }
    }
    .price-checked {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .other-price {
        display: flex;
        align-items: center;
        padding-left: 60px;
        .el-input {
          width: 80px;
        }
      }
      .checked {
        display: flex;
        align-items: center;
        padding-right: 30px;
      }
    }
    .express-inquiry {
      margin-top: 10px;
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
  }
  .throw-rule {
    height: 32px;
    display: flex;
    align-items: center;
    margin-left: 16px;
    font-size: 14px;
    color: #666;
  }
  .w100 {
    width: 100px;
  }
  .first-weight {
    margin-left: 16px;
  }
  .first-weight-val {
    width: 128px!important;
  }
}
</style>
<style lang="scss">
.add-logistics {
  .throw-rule {
    .w100 {
      .el-input__suffix {
        height: 32px;
        top: 0px;
        .el-input__icon {
          line-height: 32px;
        }
      }
    }
  }
}
</style>
